import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { LateralBar } from '../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import {
  DoubleTextSkeleton,
  TextSkeleton,
} from '../../../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';

export const SubscriptionHistoryListItemLoadingMobile: React.FC = () => {
  return (
    <UI.Shadow level={1} borderRadius={BoxBorder.heavy}>
      <Box p="inset.xs" w="full">
        <LateralBar
          backgroundColor="product.rendavariavel"
          borderTopLeftRadius="sm"
          borderBottomLeftRadius="sm"
        />
        <VStack justifyContent="space-between" space="stack.nano">
          <DoubleTextSkeleton w="65%" />
          <HStack justifyContent="space-between" space="inline.nano">
            <Stack w="3/5">
              <DoubleTextSkeleton />
            </Stack>
            <Stack w="2/6" alignItems="end">
              <DoubleTextSkeleton w="full" />
            </Stack>
          </HStack>
          <HStack justifyContent="space-between" space="inline.nano">
            <Stack w="3/5">
              <DoubleTextSkeleton />
            </Stack>
            <Stack w="2/6" alignItems="end">
              <DoubleTextSkeleton w="full" />
            </Stack>
          </HStack>
          <Stack alignSelf="end" alignItems="end">
            <TextSkeleton w="100px" />
          </Stack>
        </VStack>
      </Box>
    </UI.Shadow>
  );
};
